import { Pool } from "../utils/Pool";
export class Rectangle {
    constructor(x = 0, y = 0, width = 0, height = 0) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    get right() {
        return this.x + this.width;
    }
    set right(value) {
        this.width = value - this.x;
    }
    get bottom() {
        return this.y + this.height;
    }
    set bottom(value) {
        this.height = value - this.y;
    }
    setTo(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        return this;
    }
    reset() {
        this.x = this.y = this.width = this.height = 0;
        return this;
    }
    recover() {
        if (this == Rectangle.TEMP || this == Rectangle.EMPTY) {
            return;
        }
        Pool.recover("Rectangle", this.reset());
    }
    static create() {
        return Pool.getItemByClass("Rectangle", Rectangle);
    }
    copyFrom(source) {
        this.x = source.x;
        this.y = source.y;
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    contains(x, y) {
        if (this.width <= 0 || this.height <= 0)
            return false;
        if (x >= this.x && x < this.right) {
            if (y >= this.y && y < this.bottom) {
                return true;
            }
        }
        return false;
    }
    intersects(rect) {
        return !(rect.x > (this.x + this.width) || (rect.x + rect.width) < this.x || rect.y > (this.y + this.height) || (rect.y + rect.height) < this.y);
    }
    intersection(rect, out) {
        if (!this.intersects(rect))
            return null;
        let x = Math.max(this.x, rect.x);
        let y = Math.max(this.y, rect.y);
        let width = Math.min(this.right, rect.right) - x;
        let height = Math.min(this.bottom, rect.bottom) - y;
        out || (out = new Rectangle());
        return out.setTo(x, y, width, height);
    }
    union(source, out) {
        let x = source.x;
        let y = source.y;
        let width = source.width;
        let height = source.height;
        out || (out = new Rectangle());
        this.cloneTo(out);
        if (width <= 0 || height <= 0)
            return out;
        if (this.width <= 0 || this.height <= 0)
            return out.setTo(x, y, width, height);
        out.addPoint(x, y);
        out.addPoint(x + width, y + height);
        return out;
    }
    scale(scaleX, scaleY) {
        this.x *= scaleX;
        this.y *= scaleY;
        this.width *= scaleX;
        this.height *= scaleY;
        return this;
    }
    toString() {
        return this.x + "," + this.y + "," + this.width + "," + this.height;
    }
    equals(rect) {
        if (!rect || rect.x !== this.x || rect.y !== this.y || rect.width !== this.width || rect.height !== this.height)
            return false;
        return true;
    }
    addPoint(x, y) {
        this.x > x && (this.width += this.x - x, this.x = x);
        this.y > y && (this.height += this.y - y, this.y = y);
        if (this.width < x - this.x)
            this.width = x - this.x;
        if (this.height < y - this.y)
            this.height = y - this.y;
        return this;
    }
    getBoundPoints(out) {
        out = out || [];
        if (this.width == 0 || this.height == 0)
            return out;
        out.push(this.x, this.y, this.x + this.width, this.y, this.x, this.y + this.height, this.x + this.width, this.y + this.height);
        return out;
    }
    static _getWrapRec(points, out) {
        out = out || new Rectangle();
        if (!points || points.length < 1)
            return out.setTo(0, 0, 0, 0);
        let i, len = points.length, minX, maxX, minY, maxY;
        minX = minY = 99999;
        maxX = maxY = -minX;
        for (i = 0; i < len; i += 2) {
            let tx = points[i];
            let ty = points[i + 1];
            minX = minX < tx ? minX : tx;
            minY = minY < ty ? minY : ty;
            maxX = maxX > tx ? maxX : tx;
            maxY = maxY > ty ? maxY : ty;
        }
        return out.setTo(minX, minY, maxX - minX, maxY - minY);
    }
    static minMaxRect(minX, minY, maxX, maxY, out) {
        out = out || new Rectangle();
        return out.setTo(minX, minY, maxX - minX, maxY - minY);
    }
    isEmpty() {
        return this.width <= 0 || this.height <= 0;
    }
    clone(out) {
        out || (out = new Rectangle());
        this.cloneTo(out);
        return out;
    }
    cloneTo(destObject) {
        destObject.x = this.x;
        destObject.y = this.y;
        destObject.width = this.width;
        destObject.height = this.height;
    }
}
Rectangle.EMPTY = new Rectangle();
Rectangle.TEMP = new Rectangle();
